// central place for contact constants
export const SUPPORT_EMAIL = "rajputchhipasamaj@gmail.com";
